import React from 'react'
import './style.css'

export default function Home() {
  return (
    <div id="Home">
      <div id='Home-Left'>
        <div id="Hi">
          <h1><strong>Hey there!</strong></h1>
          <h1><strong>I'm Kai Yu Leung.</strong></h1>
          <p><em>... or just, Kai.</em></p>
        </div>
      </div>
      <div id="Home-Right">
      </div>
    </div>
  )
}
